import React from 'react';
import SlidingPanel from 'react-sliding-side-panel';
import 'react-sliding-side-panel/lib/index.css';
import './SlidingPanel.css';

const SlidingPanelComponent = ({ isOpen, onClose, children, size }) => {
    return (
        <SlidingPanel
            type="right"
            isOpen={isOpen}
            size={size || 50}
            backdropClicked={onClose}
        >
            <div className="panel-container">
                {children}
            </div>
        </SlidingPanel>
    );
};

export default SlidingPanelComponent;
